@if (!confirming() && !acting() && !minTimeout()) {
  <span class="fake-link" (click)="confirming.set(true)">
    <ng-content />
  </span>
} @else if (confirming()) {
  <span>
    @if (warning()) {<span class="warning">{{ warning() }}</span>&nbsp;}
    {{ message() }}&nbsp;
    <a class="fake-link" (click)="confirm()" i18n>yes</a>&nbsp;/&nbsp;
    <a class="fake-link" (click)="confirming.set(false)" i18n>no</a>&nbsp;
  </span>
} @else {
  <app-loading [inline]="true" />
}
